import { render } from "./sizingTable.vue?vue&type=template&id=6e27a76c"
import script from "./sizingTable.vue?vue&type=script&lang=js"
export * from "./sizingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__